var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.showDefault)?_vm._t("default"):_vm._e(),_vm._v(_vm._s(_vm._f("properNumber")(_vm.displayValue,_vm.decimals)))],2)}
var staticRenderFns = []

export { render, staticRenderFns }